<template>
  <div
    v-click-outside="close"
    :class="$style.baseline"
  >
    <vgp-icon-button
      ref="contextMenuButton"
      :icon="{ name:'baseline' }"
      :colors="buttonColors"
      :active="isShowPopup || !!enabledBaseline"
      :disabled="isDisabled"
      @onClick="toggle"
    />

    <context-menu
      v-if="isShowPopup"
      :position="positionContext"
      style="width: 240px"
    >
      <template #body>
        <div
          v-if="!projectBaselines.length"
          :class="$style.empty"
        >
          <div
            :class="$style.icon"
            v-html="baselineIcon"
          />
          <div :class="$style.text">
            {{ locales('there_are_not_baselines') }}
          </div>
        </div>

        <div
          v-if="isAccess"
          :class="$style.button"
        >
          <vgp-button
            type="primary-border"
            small
            :label="locales('create_baseline')"
            @onClick="createBaseline"
          />
        </div>

        <div
          v-if="projectBaselines.length"
          :class="[
            $style.menu,
            'gantt_scroll',
          ]"
        >
          <div
            :class="[
              $style.menu_item,
            ]"
          >
            <div :class="$style.checkbox">
              <vgp-radio-button
                :checked="selectedNone"
                @update:checked="handleCheckbox($event, noneBaseline)"
              />
            </div>
            <div :class="[$style.title, $style.title_no_access]">
              <input
                ref="baseLineTitleInput"
                :data-baseline-item-input="noneBaseline.id"
                type="text"
                :class="$style.input"
                :value="noneBaseline.name"
                :readonly="true"
                @keydown.enter="handleTitleKeydown(noneBaseline)"
              >
            </div>
          </div>

          <div
            v-for="item in projectBaselines"
            :key="item.id"
            :class="[
              $style.menu_item
            ]"
          >
            <div :class="$style.checkbox">
              <vgp-radio-button
                :checked="enabledBaseline && enabledBaseline.id === +item.id"
                @update:checked="handleCheckbox($event, item)"
              />
            </div>
            <div :class="$style.title">
              <input
                :data-baseline-item-input="item.id"
                type="text"
                :class="$style.input"
                :value="item.name"
                :readonly="!isAccess"
                @keydown.enter="handleTitleKeydown(item)"
                @blur="editName($event, item)"
              >
            </div>
            <div
              v-if="isAccess"
              :class="$style.icon"
              @click="handleDelete(item)"
            >
              <svg-sprite
                name="delete"
                type="regular"
                :size="24"
              />
            </div>
          </div>
        </div>
      </template>
    </context-menu>

    <core-confirm-popup
      :show="isShowDeletePopup"
      :popup-width="440"
      close-icon
      :title="locales('settings_msg_delete_baseline_confirm_title')"
      :text="locales('settings_msg_delete_baseline_confirm_text')"
      :cancel-button="{ title: locales('common_cancel'), type: 'secondary' }"
      :ok-button="{ title: locales('common_delete'), type: 'destructive' }"
      @onClickCancel="deleteConfirmCancel"
      @onClickOk="deleteConfirmOk"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import svgSprite from '$$vueCmp/VueIcon/svgSprite.vue';
import vgpButton from '$$vueCmp/globalButton/vgpButton.vue';
import vgpIconButton from '$$vueCmp/globalButton/withIcon/iconButton.vue';
import baselineIcon from '../../../svg/baselines/baseline.svg';
import coreConfirmPopup from '$$vueCmp/popups/coreConfirmPopup/coreConfirmPopup.vue';
import contextMenu from '$$vueCmp/popups/contextMenuPopup/contextMenuPopup.vue';
import _ from 'lodash';
import app from '$$app';
import rights from '../../../components/rights/index';
import VgpRadioButton from '../../common/VueComponents/radioButton/vgpRadioButton.vue';
import constants from '$$helpers/constants';

export default {
  name: 'BaselineNew',
  components: {
    VgpRadioButton,
    svgSprite,
    vgpButton,
    vgpIconButton,
    coreConfirmPopup,
    contextMenu,
  },
  props: {
    isShowPopup: {
      type: Boolean,
      default: false,
    },
    buttonColors: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: [
    'isShowBaselinePopup',
  ],
  data() {
    return {
      locales: __,
      isDisabled: false,
      positionContext: null,
      baselineIcon,
      isAccess: false,
      isDisabledItems: false,
      isShowDeletePopup: false,
      deleteItem: null,
      events: [],
      noneBaseline: { id: 'default', name: __('none_baseline') },
      selectedNone: false,
    };
  },
  computed: {
    ...mapState('baselines', ['enabledBaselines']),
    projectId() {
      const currentRoute = this.$store.getters['headerView/currentRoute'];

      return currentRoute.params.projectId;
    },
    projectBaselines() {
      if (!this.projectId) return [];

      return this.$store.state.baselines.projectBaselines[this.projectId]?.toSorted((a, b) => a.id - b.id);
    },
    enabledBaseline() {
      return this.enabledBaselines[this.projectId];
    },
  },
  watch: {
    isShowPopup: {
      handler(val) {
        this.$nextTick(() => {
          if (val) {
            this.positionContext = this.$refs.contextMenuButton.$el.getBoundingClientRect();
            this.update();
          }
        });
      },
      immediate: true,
    },
  },
  created() {
    const eventCollaboration = app.on('onAfterCollaboration', ({ event }) => {
      if (event === 'ResourceRoleUpdated' || event === 'ResourceOnProjectsUpdated') {
        this.$emit('isShowBaselinePopup', false);
      }
    });

    const eventProgress = app.on('gantt:progress:show', () => {
      // this.enabledBaselines = {};
      // this.isDisabled = true;
    });

    this.events.push(eventCollaboration);
    this.events.push(eventProgress);
  },
  beforeUnmount() {
    this.events.map(event => app.off(event));
  },
  methods: {
    toggle() {
      if (this.isDisabled) return;
      userExtAnalytics.log('header_click_baseline_icon');
      this.$emit('isShowBaselinePopup', !this.isShowPopup);
    },
    close() {
      if (!this.isShowDeletePopup) {
        this.$emit('isShowBaselinePopup', false);
      }
    },
    update() {
      this.isAccess = this.checkAccessForActiveProject();
      if (!this.enabledBaseline) {
        this.selectedNone = true;
      }
    },
    checkAccessForActiveProject() {
      return rights.project.hasRight(this.projectId, 'gantt_chart');
    },
    async updateBaselinesInUserSettings(baseline, enabled) {
      const currentBaselineSettings = this.$store.getters['user/getActivitySettings'](constants.USER_ACTIVITIES.BASELINES) || {};

      if (enabled) {
        currentBaselineSettings[this.projectId] = baseline;
      } else {
        delete currentBaselineSettings[this.projectId];
      }

      await this.$store.dispatch('user/updateActivitySettings', {
        activityName: constants.USER_ACTIVITIES.BASELINES,
        settings: !_.isEmpty(currentBaselineSettings) ? currentBaselineSettings : null,
        skipMerge: true,
      });
    },
    createBaseline() {
      this.$store.dispatch('baselines/createBaseline', { ganttId: this.projectId });
    },
    handleTitleKeydown(item) {
      document.querySelector(`[data-baseline-item-input="${item.id}"]`)?.blur();
    },
    editName(e, item) {
      let newValue = e.target.value.trim();

      if (newValue === item.name) return false;
      if (!newValue) newValue = item.name;

      this.$store.dispatch('baselines/changeBaseline', { ...item, ...{ name: newValue } });
    },
    handleDelete(item) {
      this.deleteItem = item;
      this.isShowDeletePopup = true;
    },
    deleteConfirmCancel() {
      this.deleteItem = null;
      setTimeout(() => {
        this.isShowDeletePopup = false;
      });
    },
    deleteConfirmOk() {
      if (this.deleteItem.id === this.enabledBaseline?.id) {
        this.disableBaseline(this.deleteItem);
      }

      this.$store.dispatch('baselines/deleteBaseline', this.deleteItem);
      this.update();
      this.deleteItem = null;
      setTimeout(() => {
        this.isShowDeletePopup = false;
        // this.selectedNone = true;
      });
    },
    async handleCheckbox(checked, item) {
      if (this.enabledBaseline) {
        await this.disableBaseline(this.enabledBaseline);
      }

      if (item.id === 'default') {
        this.selectedNone = true;
      } else {
        await this.enableBaseline(item);
      }
    },
    async enableBaseline(baseline) {
      this.selectedNone = false;
      await this.updateBaselinesInUserSettings(baseline, true);
      this.$store.commit('baselines/enableBaseline', baseline);
      userExtAnalytics.log('project_compare_baseline_done');
    },
    async disableBaseline(baseline) {
      this.$store.commit('baselines/disableBaseline', baseline);
      await this.updateBaselinesInUserSettings(baseline, false);
    },
  },
};
</script>

<style module src="../less/baseline.less"></style>
